import React from 'react';
import { FormGroupColumn, GroupedRow } from '../common/forms/FormElements';
import './CrewDisplay.scss';
import { Input } from 'reactstrap';
import CrewMemberDisplay from './CrewMemberDisplay';
import CrewEquipmentDisplay from './CrewEquipmentDisplay';

export default class CrewDisplay extends React.Component {
    render() {
        const { crew, onCrewComponentsChanged, onJobUpdated, job, disabled } =
            this.props;

        if (!crew) {
            return null;
        }

        const canEditCrewName = Boolean(
            onCrewComponentsChanged &&
            job?.crewEmployeeMemberships &&
            job?.crewEquipmentMemberships &&
            !disabled
        );

        return (
            <>
                <GroupedRow>
                    <FormGroupColumn>
                        <label className="control-label">Crew Details</label>
                        <div className="d-flex">
                            <div className="w-14 my-auto">Crew Name</div>
                            <div className="w-86">
                                {onJobUpdated && (
                                    <Input
                                        type="text"
                                        maxLength={255}
                                        value={job.crewName}
                                        onChange={(e) => {
                                            job.crewName = e.target.value;
                                            onJobUpdated(job);
                                        }}
                                        disabled={!canEditCrewName}
                                    />
                                )}

                                {!onJobUpdated && <>: {crew.name}</>}
                            </div>
                        </div>
                    </FormGroupColumn>
                </GroupedRow>

                <GroupedRow>
                    <CrewMemberDisplay {...this.props} />
                    <CrewEquipmentDisplay {...this.props} />
                </GroupedRow>
            </>
        );
    }
}
